const io = require('socket.io-client');

export default function () {
    //const socket = io.connect('http://localhost:3000'); //http://localhost:3000 for developmen
    const socket = io.connect('https://www.genialskillsservice.com:3000'); //http://localhost:3000 for development

    function registerHandler(onMessageReceived) {
        socket.on('message', onMessageReceived)
    }

    function unregisterHandler() {
        socket.off('message')
    }

    socket.on('error', function (err) {

    });


    function register(name, isEmployee, cb) {
        var chatroomName = name + '_' + getReferenceId();
        socket.emit('register', chatroomName, isEmployee, cb);
    }

    function join(chatroomName, cb) {
        socket.emit('join', chatroomName, cb)
    }

    function leave(chatroomName, cb) {
        socket.emit('leave', chatroomName, cb)
    }

    function message(chatroomName, msg, cb) {
        socket.emit('message', { chatroomName, message: msg }, cb)
    }

    function getChatrooms(cb) {
        socket.emit('chatrooms', null, cb)
    }

    function getAvailableUsers(cb) {
        socket.emit('availableUsers', null, cb)
    }

    /**
     * Creates a reference ID
     * @returns {string}
     */
    function getReferenceId() {
        return 'ID-xxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    return {
        register,
        join,
        leave,
        message,
        getChatrooms,
        getAvailableUsers,
        registerHandler,
        unregisterHandler
    }
}

